import React, { useState, useEffect } from "react";
import HelmetInfo from "Components/HelmetInfo/HelmetInfo";
import BreadCrumb from "./Components/BreadCrumb/BreadCrumb";
import HomeAPI from "../../api/homeApi";
import "./Serviceinforamtion.css";

import { Link } from "react-router-dom";
import { InfinitySpin } from "react-loader-spinner";
import logo from "../../assets/logo.png";

const Service = () => {
  const [serviceData, setServiceData] = useState(null);
    const [ServicePageData, setServicePageData] = useState(null);
  
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const dataService = await HomeAPI.getOurService();
        const dataPageService = await HomeAPI.getPageService();

        setServiceData(dataService);
        setServicePageData(dataPageService);

      } catch (error) {
        console.error("Error fetching home data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (!loading) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [loading]);

  return (
    <>
      <HelmetInfo titlePage={"خدماتنا"} />

      <div className="mt-[150px]" />
      <div className="main-container bg-[#fff] mx-auto px-4 py-8 ">
        {/* Header Section */}
        <div className="flex flex-col items-center gap-4 max-w-screen-lg mx-auto">
          {/* Breadcrumb */}
          <BreadCrumb />

          {/* Title Section */}
          <div className="text-center flex items-center flex-col gap-6">
            <span className="text-lg font-medium text-[#0d6b70]"></span>
            <h1 className="text-4xl lg:text-[2.75rem] text_bold_Bukra text-[#0d6b70] leading-snug">
             {ServicePageData?.data?.sections[0]?.Posts[0]?.title}
            </h1>
            <p className="text-lg lg:text-[1rem] font-medium  w-[85%]  text-[#667680] leading-relaxed">
             {ServicePageData?.data?.sections[0]?.Posts[0]?.description}
            </p>
          </div>
        </div>
        <div className="mt-24">
          <div className="xl:scale-[92%] lg:w-[80%] max-sm:w-full md:w-[90%] xl:w-[90%] mx-auto flex flex-col items-center md:flex-row md:items-end justify-center mb-10 animate-section  transition-opacity duration-1000">
            <div className="grid max-sm:gap-6 lg:grid-cols-3 max-sm:grid-cols-1 md:grid-cols-2">
              {serviceData?.data?.map((items, index) => (
                <Link
                  key={index}
                  to={`/servicedetails/${items?.id}`}
                  data-property-1="Default"
                  className="card xl:w-[22rem] md:w-[21rem] md:mx-5 max-sm:w-[20rem] rounded-2xl"
                >
                  <div className="card-content flex flex-col items-start gap-4 w-full h-full">
                    <div className="text-[#0d6b70] text-xl font-bold 29LT_Bukra rtl:text-right w-full">
                      {items?.name}
                    </div>
                    <div className="text-gray-500 text-sm font-medium list_style w-full">
                      <span dangerouslySetInnerHTML={{
                          __html: items?.description || "",
                        }}>
                      
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Service;
